import { DB_STATE } from '~src/types/enums';
import { Tag } from 'antd';

export const offersVoucherType = (num: number) => {
  switch (num) {
    case 1:
      return 'Unit sum';
    case 2:
      return 'Offer list';
    case 3:
      return 'Upload certified document';
    case 4:
      return 'Term of service';
    default:
      return `Unknown Type - ${num}`;
  }
};

// Contract-tab, vendor's side contracts panel
// Utility function to get the offer state display component
export const getOfferStateDisplay = (state: DB_STATE, intl: any) => {
  let color = '';
  let text = 'N/A';

  switch (state) {
    case DB_STATE.DRAFT:
      color = 'blue';
      text =
        intl.formatMessage({ id: 'offer-state-participating' }) ||
        'Participating';
      break;
    case DB_STATE.AVAILABLE: // State 3 - NOW MEANS REOPEN
      color = 'orange';
      text = intl.formatMessage({ id: 'offer-state-reopen' }) || 'Reopened';
      break;
    case DB_STATE.ACCEPTED:
      color = 'green';
      text = intl.formatMessage({ id: 'offer-state-delivered' }) || 'Delivered';
      break;
    case DB_STATE.REJECTED:
    case DB_STATE.REMOVED:
      color = 'red';
      text = intl.formatMessage({ id: 'offer-state-rejected' }) || 'Rejected';
      break;
    default:
      color = 'default';
      text = intl.formatMessage({ id: 'offer-state-unknown' }) || 'Pending';
      break;
  }

  return (
    <Tag
      color={color}
      style={{
        minWidth: '100px',
        textAlign: 'center',
        fontSize: '13px',
        padding: '2px 8px',
        borderRadius: '4px',
        margin: 0,
      }}>
      {text}
    </Tag>
  );
};
